<div class="login-container">
  <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
    <div class="container-row headline">
      <h3>{{ 'shared.header.title' | translate }}</h3>
    </div>
    <div class="container-row">
      <input type="text" class="input small-input" formControlName="username"
             name="profipay-admin-login-username" id="profipay-admin-login-username"
             [placeholder]="'login.form.username.placeholder' | translate"
      >
    </div>
    <div class="container-row">
      <input type="password" class="input small-input" formControlName="password"
             name="profipay-admin-login-password" id="profipay-admin-login-password"
             [placeholder]="'login.form.password.placeholder' | translate"
      >
    </div>
    <div class="container-row">
      <button type="submit" class="btn btn-primary" [disabled]="!loginForm.valid">
        {{ 'login.form.buttons.submit' | translate }}
      </button>
    </div>
  </form>
</div>
